// @flow
import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'
import Link from 'next/link'
import type { CharacterInfoPropsType } from '../../models/Character'
import styled from 'styled-components'
import { colors } from '@components/shared'
import { useRouter } from 'next/router'
export function CharacterListItemComponent (props: CharacterInfoPropsType): React.Node {
  const {
    imageUrl,
    slug,
    description,
    signatureImageUrl
  } = props
  const router = useRouter()
  return (
      <CharacterContainer onClick={(): void => router.push(slug)}>
        <ImageContainer>
          <Link passHref href={slug}>
            <FadeInImage width={500} height={500} src={imageUrl}/>
          </Link>
        </ImageContainer>
        <SignatureAndDescContainer>
          <SignatureContainer>
            <FadeInImage src={signatureImageUrl || ''} width={200} height={400} />
          </SignatureContainer>
          <DescriptionContainer>{description}</DescriptionContainer>
        </SignatureAndDescContainer>
      </CharacterContainer>
  )
}

const DescriptionContainer = styled.div`
  font-family: "Good Sans Regular";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 130.769% */
  letter-spacing: -0.3px;
  color: ${colors.white};
  margin-top: 8px;  
  
  ${(props: any): string => config(props).media.md`
    font-size: 16px;
    margin-top: 16px;
  `}
  ${(props: any): string => config(props).media.lg`
    margin-top: 24px;
  `}
`

const SignatureContainer = styled.div`
    width: 60px;
    height: 30px;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
      width: 100px;
      height: 50px;
    `}
    ${(props: any): string => config(props).media.md`
      width: 160px;
      height: 80px;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const SignatureAndDescContainer = styled.div`
    margin-left: 16px;
    ${(props: any): string => config(props).media.md`
      margin-left: 24px;
    `}
    ${(props: any): string => config(props).media.lg`
      margin-left: 32px;
    `}
`
const CharacterContainer = styled.div`
    width: 95%;
    display: flex;
    background-color: #311E39;
    padding: 10px 10px 10px 10px;
    border-radius: 20px;
    align-items: center;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    padding: 10px 40px 10px 10px;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

const ImageContainer = styled.div`
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    img {
      border-radius: 10px;
    }
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
    img {
      border-radius: 20px;
    }
    width: 150px;
    height: 150px;
  `}
    ${(props: any): string => config(props).media.md`
    width: 200px;
    height: 200px;
  `}
`
